import { InsuranceProductType } from '../../../api/types';
import useValidator from '../../../utilities/useValidator';
import validators from '../../../utilities/validators';

const validateInsuranceProductMainDetails = () =>
    validators.compose(
        validators.requiredString('displayName'),
        validators.requiredString('legalName.defaultValue'),
        validators.requiredStringEnum('type', InsuranceProductType),
        validators.requiredString('identifier'),
        validators.requiresPeriod('period'),
        validators.requiredNumber('order'),
        validators.requiredBoolean('isActive')
    );

const useInsuranceProductValidation = (isUpdated: boolean) =>
    useValidator(
        validators.compose(
            validators.only(() => !isUpdated, validators.requiredObjectId('insurerId')),
            validateInsuranceProductMainDetails()
        )
    );

export default useInsuranceProductValidation;
